<template>
	<div id="wrapper" class="pb-5 mb-5 bg-white h-100vh">
	    <div class="container">
	        <div class="row align-items-center justify-content-center h-100">
	            <div class="col-12 col-lg-6">
	                <form class="customFotm" @submit.stop.prevent="submit()">
	                    <div class="imgcontainer text-center mb-4">
	                        <img src="../../../../static/website/images/logo.svg" alt="Logo" class="avatar">
	                    </div>
	                    <div class="loginElement position-relative">
	                    	<loader v-if="pageLoader"></loader>
	                        <h3 class="text-center yellowColor mb-4">Welcome to <span class="themecolor">Client</span> Portal</h3>
	                        <div class="form-group">
	                            <label for="uname">Email/Phone No. <!-- Address --></label>
	                            <div class="position-relative inputIcon">
	                                <input type="text" placeholder="" name="email" v-model="email" class="form-control" v-validate="'required'"><!-- |email -->
	                                <span class="iconInput"><feather type="user"></feather></span>
	                            </div>
	                            <span class="text-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</span>
	                        </div>
	                        <div class="form-group">
	                            <label for="uname">Password</label>
	                            <div class="position-relative inputIcon">
	                                <input :type="showPass?'text':'password'" placeholder=" " name="password" v-model="password" class="form-control pr-5" v-validate="'required'">
	                                <span class="iconInput" v-if="!showPass" @click="showPass = !showPass"><feather type="eye-off"></feather></span>
	                                <span class="iconInput" v-else-if="showPass" @click="showPass = !showPass"><feather type="eye"></feather></span>
	                            </div>
	                              <span class="text-danger" v-if="submitted && errors.has('password')">{{ errors.first('password') }}</span>
	                        </div>
	                        <div class="form-group d-flex align-items-center justify-content-between">
	                            <label class="checkbox">Remember me
	                                <input type="checkbox" v-model="remember_me">
	                                <span class="checkmark"></span>
	                            </label>
	                            <router-link to="/forgot-password">Forgot Password</router-link>
	                        </div>
	                        <div class="form-group">
	                            <button class="btn btn-link btn-blue w-100" type="submit">Login</button>
	                            <!-- <a href="book-appointment.html" class="btn btn-link btn-blue w-100" type="submit">Login</a> -->
	                        </div>
	                        <div class="alert alert-danger" role="alert" v-if="loginError" v-html="loginError"></div>
	                        <div class="form-group mb-0 text-center mt-3">
	                            <p class="mb-0">Don't You have an account? <router-link to="register">Sign Up here</router-link></p>
	                        </div>
	                    </div>
	                </form>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
	// var CryptoJS = require("crypto-js"); 
	// const crypto = require('crypto');
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	// import TwoFa from '../security/security'
	export default {
		name: 'App-Login',
		data() {
			return {
				pageLoader: false,
                notification_msg:'',
                notification_type:'',
				submitted: false,
				email: '',
				password: '',
				remember_me: false,
				showPass: false,
				
				code : '',
				submittedCode : false,
				gAuthenticatorEnabled : '0',
				faFlag : false,
				loginError: ''
			}
		},
		components: {
			// appTwofa : TwoFa
		},
		methods: {
			...mapActions({
				_runLogin: types.RUN_LOGIN,
    			// _runLoginWithHash: types.RUN_LOGIN_WITH_HASH,
				// _runUserLogin2FA: types.RUN_USER_LOGIN_2FA,
				//  _runstateLoad: types.RUN_STATE_LOAD,
				//  _runLogout: types.RUN_LOGOUT
			}),
			submit() {
				if(this.pageLoader){return;}
				if (this.remember_me) {
					var email = this.email;
					var password =  this.password;
					// set cookies to expire in 14 days
					this.$cookies.set("email",email,"14d");
					this.$cookies.set("password",password,"14d");
					this.$cookies.set("remember",true,"14d");
				}else {
					// reset cookies
					this.$cookies.set("email",null);
					this.$cookies.set("password",null);
					this.$cookies.set("remember",null);
				}
				const _that = this
				this.submitted = true;
				this.loginError = '';
				this.$validator.validate().then(valid => {
					if (valid) {
						let input_json = {
							'globalParams': {
								email: _that.email,
								password: _that.password
							},
							'localParams': {
								"parameter": _that
							}
						}
						_that._runLogin(input_json)
					}
				})
			}
		},
		created(){
            const _that = this
			/*if(this.$route.query.token){
				let user = {
					"password":"",
					"email":"",
					"username":"",
					"client_code":"",
					"profile":{},
					"token":this.$route.query.token,
					"loggedIn":true
				}
				
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				this._runstateLoad({'globalParams' :{},'localParams' :{ "parameter" : this,'page' : 'indexVue' }})
			}
            if(this.$route.query.verify){
                let verify = this.$route.query.verify
                this.$router.replace({ query : ''});
                this._runLoginWithHash({
                    'globalParams' :{
                        "verify" : verify
                    },
                    'localParams' :{ "parameter" : _that }
                })

            }*/
			let remember = this.$cookies.get("remember");
			if ( remember == 'true') {
				this.email = this.$cookies.get("email");
				this.password = this.$cookies.get("password");
				this.remember_me = true
			}else{
				this.email = '';
				this.password = '';
				this.remember_me = false
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/user/login.vue